<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('happy_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('happy_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P013'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/5" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('happy_desc1') }}</div>
          <div>{{ $t('happy_desc2') }}</div>
          <div>{{ $t('happy_desc3') }}</div>
          <div>{{ $t('happy_desc4') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('happy_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('happy_common_desc1') }}</div>
            <!--            <div>{{ $t('happy_common_desc2') }}</div>
            <div>{{ $t('happy_common_desc3') }}</div>-->
            <!--            <div>{{ $t('happy_common_desc4') }}</div>-->
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('happy_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 5rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!--          <div class="subDatail">-->
          <!--            <div>곶자왈 프라이빗 도슨트 투어 & 족욕 체험(80분)</div>-->
          <!--          </div>-->
          <div class="rowSpace"></div>

          <table class="web table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('happy_table1_tr1_td1') }}</td>
                <td>{{ $t('happy_table1_tr1_td2') }}</td>
                <td>{{ $t('happy_table1_tr1_td3') }}</td>
                <td>{{ $t('happy_table1_tr1_td4') }}</td>
                <td>{{ $t('happy_table1_tr1_td5') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('happy_table1_tr2_td1') }}</td>
                <td>{{ $t('happy_table1_tr2_td2') }}</td>
                <td>{{ $t('happy_table1_tr2_td3') }}</td>
                <td>{{ $t('happy_table1_tr2_td4') }}</td>
                <td>{{ $t('happy_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('happy_table1_tr1_td1') }}</td>
                <td>{{ $t('happy_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('happy_table1_tr1_td2') }}</td>
                <td>{{ $t('happy_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('happy_table1_tr1_td3') }}</td>
                <td>{{ $t('happy_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('happy_table1_tr1_td4') }}</td>
                <td>{{ $t('happy_table1_tr2_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable3">{{ $t('happy_table1_tr1_td5') }}</td>
                <td>{{ $t('happy_table1_tr2_td5') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <!--        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('happy_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="45" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('happy_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('happy_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('happy_table2_tr2_td1') }}</td>
                <td>{{ $t('happy_table2_tr2_td2') }}</td>
                <td rowspan="5">{{ $t('happy_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('happy_table2_tr3_td1') }}</td>
                <td>{{ $t('happy_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('happy_table2_tr4_td1') }}</td>
                <td>{{ $t('happy_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('happy_table2_tr5_td1') }}</td>
                <td>{{ $t('happy_table2_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('happy_table2_tr6_td1') }}</td>
                <td>{{ $t('happy_table2_tr6_td2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>-->
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('happy_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('happy_etc_desc1') }}</div>
            <div>{{ $t('happy_etc_desc2') }}</div>
            <div>{{ $t('happy_etc_desc3') }}</div>
            <div>{{ $t('happy_etc_desc4') }}</div>
            <div>{{ $t('happy_etc_desc5') }}</div>
            <!--            <div>{{ $t('happy_etc_desc6') }}</div>-->
            <div>{{ $t('happy_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P013'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/5" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'happytogether',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/happytogether_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/happytogether_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/happytogether_main_03.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/happytogether_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/happytogether_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/happytogether_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_option_01.jpg')},
      ],
      sub_items: [
        {
          title: 'happy_mainp_title1',
          desc: 'happy_mainp_desc1',
          image: require('@/assets/images/pleisure/program/happytogether_main_02.jpg'),
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}

.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/happytogether_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "happy_title": "해피투게더",
    "happy_subtitle": "제주의 숲, 식물이야기",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "happy_desc1": "제주 고유의 원시림 ‘곶자왈‘ 을 프라이빗 숲 도슨트의 해설과 함께 자연 그대로 만날 수 있습니다.",
    "happy_desc2": "오직 곶자왈 안에서만 만날 수 있는 특별한 식물과 날씨 등의 이야기로 풍부한 감수성을 불러 일으키는 액티비티 활동입니다.",
    "happy_desc3": "함께하는 일행과 담소를 나누고 힐링하는 시간을 가져보시기 바랍니다.",
    "happy_desc4": "※ 연령제한 36개월 이상",
    "happy_common_title": "공통 의전 및 서비스",
    "happy_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "happy_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "happy_common_desc3": "- 어메니티, 미니바 제공",
    "happy_common_desc4": "- F&B 세트 제공",
    "happy_main_title": "메인 프로그램",
    "happy_mainp_title1": "곶자왈 투어+족욕",
    "happy_mainp_desc1": "곶자왈 프라이빗 도슨트 투어 & 족욕 체험(80분)",
    "happy_table1_tr1_td1": "옵션",
    "happy_table1_tr1_td2": "최대인원",
    "happy_table1_tr1_td3": "소요시간",
    "happy_table1_tr1_td4": "요금(2인기준)",
    "happy_table1_tr1_td5": "추가옵션",
    "happy_table1_tr2_td1": "곶자왈 투어+족욕",
    "happy_table1_tr2_td2": "6인",
    "happy_table1_tr2_td3": "2 ~ 2.5H",
    "happy_table1_tr2_td4": "650,000",
    "happy_table1_tr2_td5": "※ 인원추가 +80,000 원 / 인",
    "happy_addition_title": "추가옵션",
    "happy_table2_tr1_td1": "구분",
    "happy_table2_tr1_td2": "옵션(2인기준)",
    "happy_table2_tr2_td1": "150,000",
    "happy_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "happy_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "happy_table2_tr3_td1": "200,000",
    "happy_table2_tr3_td2": "메디컬 스파(바디)",
    "happy_table2_tr4_td1": "350,000",
    "happy_table2_tr4_td2": "오모로비짜 스파(90분)",
    "happy_table2_tr5_td1": "400,000",
    "happy_table2_tr5_td2": "본에스티스 스파(90분)",
    "happy_table2_tr6_td1": "플라워 세팅",
    "happy_table2_tr6_td2": "300,000 / 500,000 / 700,000",
    "happy_etc_title": "기타사항",
    "happy_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "happy_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "happy_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "happy_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "happy_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "happy_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "happy_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "happy_title": "Happy Together (Forest storytelling)",
    "happy_subtitle": "Story about Jeju forest and plants.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "happy_desc1": "You can experience Jeju's unique primeval forest, Gotjawal with a commentary from a private forest docent.",
    "happy_desc2": "This activity will give you a chance to have a deep feeling about the nature while listening to stories about weather and exotic plants you can meet only in Gotjawal.",
    "happy_desc3": "Enjoy a healing time as having a talk with travel companions.",
    "happy_desc4": "※ Available only for 36 months old or older",
    "happy_common_title": "Common escort service and other services",
    "happy_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "happy_common_desc2": "- Care service by the PINX escort manager",
    "happy_common_desc3": "- Free amenities and minibar",
    "happy_common_desc4": "- Complimentary F&B sets",
    "happy_main_title": "Main Program",
    "happy_mainp_title1": "Gotjawal Tour + Foot bath",
    "happy_mainp_desc1": "Gotjawal Private docent tour & Foot bath(80min.)",
    "happy_table1_tr1_td1": "Option",
    "happy_table1_tr1_td2": "Maximum Occupancy",
    "happy_table1_tr1_td3": "Total Time",
    "happy_table1_tr1_td4": "Fare(2 people)",
    "happy_table1_tr1_td5": "Additional option",
    "happy_table1_tr2_td1": "Gotjawal Tour + Foot bath",
    "happy_table1_tr2_td2": "6 person",
    "happy_table1_tr2_td3": "2 ~ 2.5H",
    "happy_table1_tr2_td4": "KRW 6500,000",
    "happy_table1_tr2_td5": "※ Additional person + KRW 80,000/ 1person",
    "happy_addition_title": "Additional Options",
    "happy_table2_tr1_td1": "Fare",
    "happy_table2_tr1_td2": "Option(2 person)",
    "happy_table2_tr2_td1": "KRW 150,000",
    "happy_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.)",
    "happy_table2_tr2_td3": "※ More than 3 people, please contact us",
    "happy_table2_tr3_td1": "KRW 200,000",
    "happy_table2_tr3_td2": "Medical Spa(Body)",
    "happy_table2_tr4_td1": "KRW 350,000",
    "happy_table2_tr4_td2": "Omorovicza Spa(90 min)",
    "happy_table2_tr5_td1": "KRW 400,000",
    "happy_table2_tr5_td2": "Vonestis Spa(90 min)",
    "happy_table2_tr6_td1": "Flower service",
    "happy_table2_tr6_td2": "KRW 300,000 / 500,000 / 700,000",
    "happy_etc_title": "Others",
    "happy_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "happy_etc_desc2": "※ In some cases, minors may need a guardian.",
    "happy_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "happy_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "happy_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "happy_etc_desc6": "※ Traveler's insurance is included in the product.",
    "happy_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "happy_title": "해피투게더",
    "happy_subtitle": "제주의 숲, 식물이야기",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "happy_desc1": "제주 고유의 원시림 ‘곶자왈‘ 을 프라이빗 숲 도슨트의 해설과 함께 자연 그대로 만날 수 있습니다.",
    "happy_desc2": "오직 곶자왈 안에서만 만날 수 있는 특별한 식물과 날씨 등의 이야기로 풍부한 감수성을 불러 일으키는 액티비티 활동입니다.",
    "happy_desc3": "함께하는 일행과 담소를 나누고 힐링하는 시간을 가져보시기 바랍니다.",
    "happy_desc4": "※ 연령제한 36개월 이상",
    "happy_common_title": "공통 의전 및 서비스",
    "happy_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "happy_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "happy_common_desc3": "- 어메니티, 미니바 제공",
    "happy_common_desc4": "- F&B 세트 제공",
    "happy_main_title": "메인 프로그램",
    "happy_mainp_title1": "곶자왈 투어+족욕",
    "happy_mainp_desc1": "곶자왈 프라이빗 도슨트 투어 & 족욕 체험(80분)",
    "happy_table1_tr1_td1": "옵션",
    "happy_table1_tr1_td2": "최대인원",
    "happy_table1_tr1_td3": "소요시간",
    "happy_table1_tr1_td4": "요금(2인기준)",
    "happy_table1_tr1_td5": "추가옵션",
    "happy_table1_tr2_td1": "곶자왈 투어+족욕",
    "happy_table1_tr2_td2": "6인",
    "happy_table1_tr2_td3": "2 ~ 2.5H",
    "happy_table1_tr2_td4": "6500,000",
    "happy_table1_tr2_td5": "※ 인원추가 +80,000 원 / 인",
    "happy_addition_title": "추가옵션",
    "happy_table2_tr1_td1": "구분",
    "happy_table2_tr1_td2": "옵션(2인기준)",
    "happy_table2_tr2_td1": "150,000",
    "happy_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "happy_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "happy_table2_tr3_td1": "200,000",
    "happy_table2_tr3_td2": "메디컬 스파(바디)",
    "happy_table2_tr4_td1": "350,000",
    "happy_table2_tr4_td2": "오모로비짜 스파(90분)",
    "happy_table2_tr5_td1": "플라워 세팅",
    "happy_table2_tr5_td2": "300,000 / 500,000 / 700,000",
    "happy_etc_title": "기타사항",
    "happy_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "happy_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "happy_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "happy_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "happy_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "happy_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "happy_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
